(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- drifting postcards ---------- */
  (function drift(){
    if(reduce) return;
    var host = document.getElementById('drift');
    if(!host) return;
    var art = ['#art-aurora','#art-krakow','#art-foss','#art-tatry','#art-reynis','#art-warsaw','#art-kirkju','#art-route','#art-winter','#art-lagoon'];
    var anims = ['driftA','driftB','driftC','driftD'];
    var cfg = [
      {w:230, d:78,  y:'6vh',  del:-4},
      {w:160, d:104, y:'58vh', del:-34},
      {w:280, d:126, y:'30vh', del:-70},
      {w:132, d:92,  y:'78vh', del:-16},
      {w:196, d:138, y:'44vh', del:-96},
      {w:118, d:86,  y:'16vh', del:-52},
      {w:250, d:150, y:'68vh', del:-120},
      {w:150, d:112, y:'86vh', del:-62}
    ];
    var frag = document.createDocumentFragment();
    cfg.forEach(function(c,i){
      var d = document.createElement('div');
      d.className = 'fly';
      d.style.width = c.w + 'px';
      d.style.top = c.y;
      d.style.left = '0';
      d.style.animationName = anims[i % anims.length];
      d.style.animationDuration = c.d + 's';
      d.style.animationDelay = c.del + 's';
      d.innerHTML = '<div class="mini"><svg viewBox="0 0 400 280" style="width:100%;height:auto;display:block"><use href="'+art[i % art.length]+'"/></svg></div>';
      frag.appendChild(d);
    });
    host.appendChild(frag);
  })();

  /* ---------- header shadow + background parallax ---------- */
  var hdr = document.getElementById('hdr');
  var bg  = document.getElementById('bgFixed');
  var ticking = false;
  function onScroll(){
    if(ticking) return;
    ticking = true;
    requestAnimationFrame(function(){
      var y = window.pageYOffset;
      if(hdr) hdr.classList.toggle('stuck', y > 24);
      if(bg && !reduce) bg.style.transform = 'translate3d(0,' + (-y * 0.13) + 'px,0)';
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll();

  /* ---------- reveal on scroll ---------- */
  var rv = document.querySelectorAll('.rv');
  function showRv(){
    rv.forEach(function(el){ el.classList.add('in'); });
  }
  if('IntersectionObserver' in window && !reduce && rv.length){
    document.documentElement.classList.add('js-reveal');
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(e.isIntersecting){
          var i = +(e.target.getAttribute('data-d') || 0);
          setTimeout(function(){ e.target.classList.add('in'); }, i * 90);
          io.unobserve(e.target);
        }
      });
    }, {threshold:.01, rootMargin:'0px 0px 0px 0px'});
    rv.forEach(function(el){ io.observe(el); });
    setTimeout(showRv, 1800);
  } else {
    showRv();
  }

  /* ---------- announcement rotator ---------- */
  (function anno(){
    var box = document.getElementById('annoSlides');
    if(!box) return;
    var s = box.querySelectorAll('.slide'), i = 0;
    setInterval(function(){
      s[i].classList.remove('on');
      i = (i + 1) % s.length;
      s[i].classList.add('on');
    }, 4600);
  })();

  /* ---------- drawer / mobile nav ---------- */
  var scrim = document.getElementById('scrim');
  var drawer = document.getElementById('drawer');
  var mnav = document.getElementById('mnav');
  function open(el){ el && el.classList.add('on'); scrim && scrim.classList.add('on'); document.body.style.overflow='hidden'; }
  function closeAll(){
    drawer && drawer.classList.remove('on');
    mnav && mnav.classList.remove('on');
    scrim && scrim.classList.remove('on');
    document.body.style.overflow='';
  }
  var cartBtn = document.getElementById('cartBtn');
  cartBtn && cartBtn.addEventListener('click', function(){ open(drawer); });
  var burger = document.getElementById('burger');
  burger && burger.addEventListener('click', function(){ open(mnav); });
  ['drawerClose','mnavClose'].forEach(function(id){
    var b = document.getElementById(id); b && b.addEventListener('click', closeAll);
  });
  scrim && scrim.addEventListener('click', closeAll);
  document.addEventListener('keydown', function(e){
    if(e.key !== 'Escape') return;
    var zl = document.getElementById('zoomLayer');
    if(zl && zl.classList.contains('on')) return;
    closeAll();
  });
  document.querySelectorAll('.mnav a').forEach(function(a){ a.addEventListener('click', closeAll); });

  /* ---------- toast ---------- */
  var tEl = document.getElementById('toast'), tTimer;
  window.toast = function(msg){
    if(!tEl) return;
    tEl.textContent = msg || 'Added to basket';
    tEl.classList.add('on');
    clearTimeout(tTimer);
    tTimer = setTimeout(function(){ tEl.classList.remove('on'); }, 2600);
  };

  /* ---------- add to cart (demo) ---------- */
  var count = 2;
  window.addToCart = function(name){
    count++;
    var b = document.getElementById('cartCount');
    if(b) b.textContent = count;
    toast((name ? name + ' - ' : '') + 'added to basket');
  };
  document.querySelectorAll('[data-add]').forEach(function(b){
    b.addEventListener('click', function(e){
      e.preventDefault();
      addToCart(b.getAttribute('data-add'));
    });
  });

  /* ---------- card tilt ---------- */
  if(!reduce && window.matchMedia('(pointer:fine)').matches){
    document.querySelectorAll('.tilt').forEach(function(card){
      var host = card.closest('.media') || card.parentElement;
      host.addEventListener('pointermove', function(e){
        var r = host.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - .5;
        var py = (e.clientY - r.top) / r.height - .5;
        card.style.transform = 'rotateY(' + (px * 9) + 'deg) rotateX(' + (-py * 7) + 'deg) translateZ(14px)';
      });
      host.addEventListener('pointerleave', function(){ card.style.transform = ''; });
    });
  }

  /* ---------- accordions ---------- */
  document.querySelectorAll('.acc').forEach(function(acc){
    var btn = acc.querySelector('button'), body = acc.querySelector('.body');
    btn.addEventListener('click', function(){
      var on = acc.classList.toggle('on');
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      body.style.maxHeight = on ? body.scrollHeight + 'px' : '0px';
    });
    if(acc.classList.contains('on')){
      body.style.maxHeight = body.scrollHeight + 'px';
      btn.setAttribute('aria-expanded','true');
    }
  });

  /* ---------- product options ---------- */
  document.querySelectorAll('[data-optgroup]').forEach(function(g){
    var out = document.querySelector('[data-optout="' + g.getAttribute('data-optgroup') + '"]');
    g.querySelectorAll('.sw').forEach(function(sw){
      sw.addEventListener('click', function(){
        if(sw.classList.contains('dis')) return;
        g.querySelectorAll('.sw').forEach(function(o){ o.setAttribute('aria-pressed','false'); });
        sw.setAttribute('aria-pressed','true');
        if(out) out.textContent = sw.getAttribute('data-label') || sw.textContent.trim();
        if(window.recalc) window.recalc();
      });
    });
  });

  /* ---------- product price (Shopify live vs mockup demo) ---------- */
  var productJsonEl = document.getElementById('ProductJson');
  var productData = null;
  if(productJsonEl){
    try { productData = JSON.parse(productJsonEl.textContent); } catch (e) { productData = null; }
  }

  window.recalc = function(){
    var el = document.getElementById('pdpPrice');
    if(!el) return;

    if(productData && productData.variants && productData.variants.length){
      var opts = [];
      document.querySelectorAll('.product-form .opt').forEach(function(g){
        var sw = g.querySelector('.sw[aria-pressed="true"]');
        opts.push(sw ? sw.getAttribute('data-label') : '');
      });
      var variant = productData.variants.find(function(v){
        if(!v.options || v.options.length !== opts.length) return productData.variants.length === 1;
        return opts.every(function(o, i){ return String(v.options[i]) === String(o); });
      }) || productData.variants[0];
      el.textContent = variant.price_money;
      var was = document.getElementById('pdpWas');
      if(was){
        if(variant.compare_money){ was.textContent = variant.compare_money; was.style.display = ''; }
        else { was.style.display = 'none'; }
      }
      var idInput = document.querySelector('.product-form input[name="id"]');
      if(idInput && variant.id) idInput.value = variant.id;
      return;
    }

    if(el.getAttribute('data-live-price')) return;

    var base = 2400;
    var f = document.querySelector('[data-optgroup="finish"] .sw[aria-pressed="true"]');
    var s = document.querySelector('[data-optgroup="set"] .sw[aria-pressed="true"]');
    var m = document.querySelector('[data-optgroup="format"] .sw[aria-pressed="true"]');
    var q = document.getElementById('qtyVal');
    var total = base;
    if(f) total += +(f.getAttribute('data-delta') || 0);
    if(m) total *= +(m.getAttribute('data-mult') || 1);
    if(s) total *= +(s.getAttribute('data-mult') || 1);
    total *= (q ? +q.textContent : 1);
    var code = (window.kartkaMoney && window.kartkaMoney.currency) || 'ISK';
    el.textContent = Math.round(total).toLocaleString('de-DE') + ' ' + code;
  };

  /* ---------- quantity ---------- */
  document.querySelectorAll('[data-qty]').forEach(function(w){
    var val = w.querySelector('span'), btns = w.querySelectorAll('button');
    btns[0].addEventListener('click', function(){ var n = Math.max(1, +val.textContent - 1); val.textContent = n; var q = document.getElementById('qtyInput'); if(q) q.value = n; window.recalc && recalc(); });
    btns[1].addEventListener('click', function(){ var n = Math.min(99, +val.textContent + 1); val.textContent = n; var q = document.getElementById('qtyInput'); if(q) q.value = n; window.recalc && recalc(); });
  });

  /* ---------- gallery thumbs + zoom ---------- */
  document.querySelectorAll('[data-thumb]').forEach(function(t){
    t.addEventListener('click', function(){
      document.querySelectorAll('[data-thumb]').forEach(function(o){ o.setAttribute('aria-selected','false'); });
      t.setAttribute('aria-selected','true');
      var use = document.querySelector('#galMain use');
      var img = document.querySelector('#galMain img');
      var href = t.getAttribute('data-thumb');
      if(href && href.indexOf('#') === 0 && use) use.setAttribute('href', href);
      if(href && href.indexOf('#') !== 0){
        if(img){
          img.src = href;
          img.removeAttribute('width');
          img.removeAttribute('height');
          img.classList.add('pdp-photo');
        } else if(document.getElementById('galMain')){
          document.getElementById('galMain').insertAdjacentHTML('afterbegin', '<img class="pdp-photo" src="'+href+'" alt="">');
        }
      }
      var cap = document.getElementById('galCap');
      if(cap && t.getAttribute('data-cap')) cap.textContent = t.getAttribute('data-cap');
    });
  });

  (function zoomView(){
    var layer = document.getElementById('zoomLayer');
    var card = document.getElementById('zoomCard');
    var main = document.getElementById('galMain');
    if(!layer || !card || !main) return;
    function openZoom(){
      card.innerHTML = '';
      var img = main.querySelector('img');
      var svg = main.querySelector('svg');
      if(img) card.appendChild(img.cloneNode(true));
      else if(svg) card.appendChild(svg.cloneNode(true));
      layer.classList.add('on');
      layer.setAttribute('aria-hidden','false');
      document.body.style.overflow = 'hidden';
    }
    function closeZoom(){
      layer.classList.remove('on');
      layer.setAttribute('aria-hidden','true');
      if(!document.getElementById('drawer') || !document.getElementById('drawer').classList.contains('on')){
        document.body.style.overflow = '';
      }
    }
    main.setAttribute('role','button');
    main.setAttribute('tabindex','0');
    main.setAttribute('aria-label','View larger');
    main.addEventListener('click', openZoom);
    main.addEventListener('keydown', function(e){
      if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); openZoom(); }
    });
    var closeBtn = document.getElementById('zoomClose');
    closeBtn && closeBtn.addEventListener('click', function(e){ e.stopPropagation(); closeZoom(); });
    layer.addEventListener('click', function(e){ if(e.target === layer) closeZoom(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && layer.classList.contains('on')) closeZoom(); });
  })();

  /* ---------- recipient toggle ---------- */
  var sw = document.getElementById('sendSwitch');
  if(sw){
    sw.addEventListener('click', function(){
      var on = sw.getAttribute('aria-checked') !== 'true';
      sw.setAttribute('aria-checked', on ? 'true' : 'false');
      var f = document.getElementById('sendFields');
      if(f) f.style.display = on ? 'block' : 'none';
    });
  }

  /* ---------- newsletter demo ---------- */
  document.querySelectorAll('form[data-demo]').forEach(function(f){
    f.addEventListener('submit', function(e){ e.preventDefault(); toast('Thank you - please confirm via email'); f.reset(); });
  });

  window.recalc && window.recalc();

  /* ---------- Shopify: search, localization, cart, send-for-me ---------- */
  var searchBtn = document.querySelector('[data-open-search]');
  var searchModal = document.getElementById('searchModal');
  var searchClose = document.getElementById('searchClose');
  var searchInput = searchModal && searchModal.querySelector('input[type="search"]');
  if(searchBtn && searchModal){
    searchBtn.addEventListener('click', function(){
      searchModal.classList.add('on');
      document.body.style.overflow = 'hidden';
      if(searchInput) setTimeout(function(){ searchInput.focus(); }, 40);
    });
  }
  if(searchClose && searchModal){
    searchClose.addEventListener('click', function(){
      searchModal.classList.remove('on');
      document.body.style.overflow = '';
    });
  }
  if(searchModal){
    searchModal.addEventListener('click', function(e){
      if(e.target === searchModal){
        searchModal.classList.remove('on');
        document.body.style.overflow = '';
      }
    });
  }

  /* Language/country submit lives on the select onchange (kartkaSubmitLocale in theme.liquid)
     so it does not depend on this deferred file. */
  var sendFields = document.getElementById('sendFields');
  var sendHidden = document.getElementById('sendForMeValue');
  function syncSendFields(){
    var on = sw && sw.getAttribute('aria-checked') === 'true';
    if(sendHidden) sendHidden.value = on ? 'Posted to recipient' : 'Ship to me';
    if(!sendFields) return;
    sendFields.querySelectorAll('input, textarea').forEach(function(el){
      el.disabled = !on;
      if(el.hasAttribute('data-required')) el.required = !!on;
    });
  }
  if(sw){
    sw.addEventListener('click', syncSendFields);
    syncSendFields();
  }

  function bindDrawerChrome(){
    drawer = document.getElementById('drawer');
    var closeBtn = document.getElementById('drawerClose');
    closeBtn && closeBtn.addEventListener('click', closeAll);
  }

  function refreshCartDrawer(html){
    if(!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.getElementById('drawer');
    var current = document.getElementById('drawer');
    if(next && current) current.replaceWith(next);
    var nextCount = doc.getElementById('cartCount');
    var countEl = document.getElementById('cartCount');
    if(nextCount && countEl) countEl.textContent = nextCount.textContent;
    bindDrawerChrome();
    bindCartWrite();
  }

  function bindCartWrite(){
    document.querySelectorAll('[data-line-write]').forEach(function(form){
      if(form.getAttribute('data-bound')) return;
      form.setAttribute('data-bound','1');
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var key = form.getAttribute('data-key');
        var qty = parseInt(form.getAttribute('data-qty'), 10) || 1;
        var props = { Delivery: 'Posted to recipient' };
        ['Recipient name','Recipient address','Message','Posting date'].forEach(function(n){
          var el = form.querySelector('[name="'+n+'"]');
          props[n] = el ? el.value : '';
        });
        if(!window.Shopify){
          toast('Words saved - on the live shop they print on the order');
          return;
        }
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty, properties: props })
        }).then(function(res){
          if(!res.ok) throw res;
          if(!form.closest('#drawer')){
            window.location.reload();
            return null;
          }
          return fetch(window.location.pathname + (window.location.search || ''));
        }).then(function(r){
          if(!r) return;
          return r.text();
        }).then(function(html){
          if(!html) return;
          refreshCartDrawer(html);
          toast('Words saved for this card');
          open(document.getElementById('drawer'));
        }).catch(function(){
          toast('Could not save the words - try Send for me on the product page');
        });
      });
    });
  }

  function shopifyAdd(form){
    var data = new FormData(form);
    return fetch(window.Shopify ? (window.routes && window.routes.cart_add_url || '/cart/add.js') : '/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    }).then(function(res){
      if(!res.ok) throw res;
      return fetch('/cart.js');
    }).then(function(){
      return fetch(window.location.pathname + (window.location.search || ''));
    }).then(function(r){ return r.text(); }).then(function(html){
      refreshCartDrawer(html);
      toast('Added to basket');
      open(document.getElementById('drawer'));
    }).catch(function(){
      form.submit();
    });
  }

  document.querySelectorAll('form.product-form, form[data-quick-add]').forEach(function(form){
    form.addEventListener('click', function(e){ e.stopPropagation(); });
    form.addEventListener('submit', function(e){
      if(!window.Shopify) return;
      e.preventDefault();
      shopifyAdd(form);
    });
  });
  bindCartWrite();
})();
